import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Restricted = () => {
  document.title = "Could not sign up...";

  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/sign-up")
    }, 4 * 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <div className="flex flex-col items-center justify-center">
        <p className="flex items-center space-x-2 text-center">
          {"Please sign up using your business or work email address."}
        </p>
        <p className="flex items-center space-x-2 pt-4">
          <a href="/sign-up">Go back</a>
        </p>
      </div>
    </>
  );
};

export default Restricted;
